/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Video section configuration for challenge pages. Separate from hero, supports autoplay with mute toggle.
 * @export
 * @interface ChallengeVideoSection
 */
export interface ChallengeVideoSection {
    /**
     * Whether to show the video section on the page
     * @type {boolean}
     * @memberof ChallengeVideoSection
     */
    showOnPage?: boolean;
    /**
     * URL to video file (MP4 format recommended)
     * @type {string}
     * @memberof ChallengeVideoSection
     */
    videoUrl?: string;
    /**
     * Asset ID for video poster/thumbnail image
     * @type {string}
     * @memberof ChallengeVideoSection
     */
    posterImageId?: string;
    /**
     * CDN URL for poster image (in response)
     * @type {string}
     * @memberof ChallengeVideoSection
     */
    posterImageUrl?: string;
    /**
     * Whether video should autoplay (muted by default)
     * @type {boolean}
     * @memberof ChallengeVideoSection
     */
    autoplay?: boolean;
    /**
     * Whether video should loop
     * @type {boolean}
     * @memberof ChallengeVideoSection
     */
    loop?: boolean;
}

/**
 * Check if a given object implements the ChallengeVideoSection interface.
 */
export function instanceOfChallengeVideoSection(value: object): value is ChallengeVideoSection {
    return true;
}

export function ChallengeVideoSectionFromJSON(json: any): ChallengeVideoSection {
    return ChallengeVideoSectionFromJSONTyped(json, false);
}

export function ChallengeVideoSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeVideoSection {
    if (json == null) {
        return json;
    }
    return {
        
        'showOnPage': json['showOnPage'] == null ? undefined : json['showOnPage'],
        'videoUrl': json['videoUrl'] == null ? undefined : json['videoUrl'],
        'posterImageId': json['posterImageId'] == null ? undefined : json['posterImageId'],
        'posterImageUrl': json['posterImageUrl'] == null ? undefined : json['posterImageUrl'],
        'autoplay': json['autoplay'] == null ? undefined : json['autoplay'],
        'loop': json['loop'] == null ? undefined : json['loop'],
    };
}

export function ChallengeVideoSectionToJSON(json: any): ChallengeVideoSection {
    return ChallengeVideoSectionToJSONTyped(json, false);
}

export function ChallengeVideoSectionToJSONTyped(value?: ChallengeVideoSection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'showOnPage': value['showOnPage'],
        'videoUrl': value['videoUrl'],
        'posterImageId': value['posterImageId'],
        'posterImageUrl': value['posterImageUrl'],
        'autoplay': value['autoplay'],
        'loop': value['loop'],
    };
}

